/* eslint-disable @stylistic/comma-dangle */

import { messages as commonLocale }	from "@geotoura/common/locale_de";
import { sharedLocale }	from "@geotoura/shared/sharedLocale_de";
import { siteInfo }		from "@geotoura/shared/siteInfo_de";

// NOTE apart from "general" (which is for generic texts used by several components) all other entries should be named after their component and ordered alphabetically

export const messages = {
	general: {
		and:			"und",
		cancel:			"Abbrechen",
		category:		"Kategorie",
		close:			"Schließen",
		closeDialog:	"Dialog schließen",
		defHotel:		"Ort mit ausgesuchten Hotels",
		defDaytrip:		"Ausflugsziel",
		defAirport:		"Ort mit Flughafen",
		help:			"Hilfe",
		impressum:		{ href: siteInfo.page.impressum, text: "Impressum" },
		night:			"Nacht",
		nights:			"Nächte",
		remove:			"entfernen",
		stop:			"Station",
		stops:			"Stationen",
	},
	activitylist: {
		title:	"Erlebnisse",
		intro:	"Zu einer perfekten Reise gehören für uns nicht nur ausgesuchte Hotels, sondern auch einmalige Erlebnisse. Die folgenden Angebote können Sie bei einem Besuch in dieser Stadt buchen.",
	},
	app: {
		contentShow:	"Infos zeigen",
		contentHide:	"Infos verbergen",
	},
	counter: {
		up:		"um eins erhöhen",
		down:	"um eins verringern"
	},
	destination: {
		scrollTop:	"Hoch zum Anfang"
	},
	destinationInfo: {
		addToRoute:			"Zu meiner Route hinzufügen",
		addToRouteShort:	"Auf meine Route",
		removeFromRoute:	"Aus meiner Route entfernen",
		station:			(nr:string):string => `Station ${nr}`,
		stationSuffix:		" der Route",
		removeInRoute:		"entfernen und zum nächsten Ort wechseln",
		nights: {
			nrnights:				"Übernachtungen",
			nrnightsShort:			"Nächte",
			recommendedStay:		"Unsere Empfehlung: ",
			recommendedStayShort:	"Unser Tipp:",
			labelPlus:				"Nächte um eins erhöhen",
			labelMinus:				"Nächte um eins verringern",
		}
	},
	footer: [
		{ href: siteInfo.page.privacy,		text: "Datenschutz" },
		{ href: siteInfo.page.arb,			text: "ARB (Allgemeine Reisebedingungen)" },
		{ href: siteInfo.page.impressum,	text: "Impressum" }
	],
	gallery: {
		fotos:	"Fotos",
	},
	hotel: {
		selectCategory:	"Hotel auswählen",
		selected:		"Ausgewähltes Hotel"
	},
	hotelFeatured: {
		note:			"Hinweis",
		severalCats:	"Dieses Hotel erscheint in mehreren Hotelkategorien, weil es über Zimmer für unterschiedliche Qualitätsansprüche verfügt."
	},
	hotelList: {
		title:		"Hotels",
		catIntro:	"Wenn wir ein Hotel in unser Programm aufnehmen, ist uns nicht nur ein hoher Qualitätsstandard wichtig. Wir bevorzugen auch landestypische Unterkünfte mit speziellem Ambiente. Wir teilen unsere Hotels in vier eigene Geotoura-Kategorien ein.",
		cat1:		"Unsere preisgünstigste Variante. Liebevoll eingerichtete Zimmer, die alles bieten, was der anspruchsvolle Reisende erwartet.",
		cat2:		"Hotels mit besonderem Ambiente: Historische Paläste, Klöster, Haciendas oder Strand-Hotels mit außergewöhnlichem Charme. Perfekt für die klassische Kulturrundreise.",
		cat3:		"Luxuriöse Hotels in ausgezeichneter Lage und mit höchstem Komfort, oft in jahrhundertealten Adelspalästen, alten Ölmühlen oder Haciendas.",
		cat4:		"Für die Flitterwochen – span. Luna de miel – oder wenn Sie sich etwas Außergewöhnliches gönnen wollen …",
	},
	help: {
		title:	"So funktioniert der Geotoura-Reiseplaner",
		step1: {
			title:	"Wählen Sie Ihre Wunschziele auf der Karte",
		},
		step2: {
			title:	"Fügen Sie die Orte Ihrer Route hinzu",
			text:	"Wählen Sie aus unseren Besichtigungstipps, Hotels und Events, wohin Ihre Reise Sie führen soll und was Sie dort erleben wollen.",
		},
		step3: {
			title:	"Fordern Sie Ihr kostenloses Reiseangebot an",
			text:	"Per Mail erhalten Sie von uns ein kostenloses und unverbindliches Angebot für Ihre maßgeschneiderte Individualreise.",
		},
		outro:			"Passt schließlich alles, können Sie genau diese Reise bei uns buchen – wir kümmern uns um alles: Flug, Mietwagen, Hotels und all die kleinen Extras, die eine Reise mit Geotoura besonders machen.",
		buttonTitle:	"Los geht’s!"
	},
	howtoStart: {
		title:	"Traumhafter Urlaub, ganz einfach und ganz nach Ihrem Geschmack",
		step1: {
			title:			"Route auswählen",
			withoutRoute:	"Ohne Route",
		},
		step2: {
			title:	"Stationen anpassen",
			text:	"Hotels, Ausflüge und Erlebnisse, wählen Sie aus unseren Besichtigungstipps ganz nach Ihren Wünschen",
		},
		step3: {
			title:	"Traumroute anfragen",
			text:	"Per Mail erhalten Sie von uns ein kostenloses und unverbindliches Angebot mit maßgeschneiderten Vorschlägen.",
		},
		outro:			"Haben Sie Ihre Traumreise zusammengestellt, kümmern wir uns um den ganzen Rest: Flug, Mietwagen, Hotels und all die kleinen Extras, die eine Reise mit Geotoura besonders machen.",
		buttonTitle:	"Jetzt Route planen"
	},
	howtoHelp: {
		title:		"So funktioniert der Geotoura-Reiseplaner",
		step1: {
			title:	"Wählen Sie Ihre Wunschziele auf der Karte",
		},
		step2: {
			title:	"Fügen Sie die Orte Ihrer Route hinzu",
			text:	"Wählen Sie aus unseren Besichtigungstipps, Hotels und Events, wohin Ihre Reise Sie führen soll und was Sie dort erleben wollen.",
		},
		step3: {
			title:	"Fordern Sie Ihr kostenloses Reiseangebot an",
			text:	"Per Mail erhalten Sie von uns ein kostenloses und unverbindliches Angebot für Ihre maßgeschneiderte Individualreise.",
		},
		outro:			"Passt schließlich alles, können Sie genau diese Reise bei uns buchen – wir kümmern uns um alles: Flug, Mietwagen, Hotels und all die kleinen Extras, die eine Reise mit Geotoura besonders machen.",
		buttonTitle:	"Los geht’s!"
	},
	legend: {
		title:	"Legende",
	},
	lightbox: {
		title:		"Lightbox",
		previous:	"Vorheriges Bild anzeigen",
		next:		"Nächstes Bild anzeigen"
	},
	nearbylist: {
		title:	"Nächste Reiseziele"
	},
	nearby: {
		hintHotel:		"An diesem Ort bieten wir Hotels an",
		hintDaytrip:	"Ein lohnender Tagesausflug",
	},
	overwriteRoute: {
		title:				"Gespeicherte Route gefunden",
		message1:			"Sie sind über einen Link hierhergekommen, der die von Geotoura zusammengestellte Route",
		message2:			"lädt. In Ihrem Browser ist aber bereits eine Route mit ",
		message3:			" von einem früheren Besuch des Urlaubsplaners gespeichert. Mit welcher Route wollen Sie weitermachen?",
		cancelTitle:		"Gespeicherte Route behalten",
		confirmTitle:		"Geotoura-Route laden",
	},
	territorylist: {
		entryUrl:	siteInfo.page.main,
		intro:		"Wohin wollen Sie reisen?",
		logo:		"logo-white-DE.svg"
	},
	request: {
		title:				"Schicken Sie mir ein Reiseangebot",
		buttonRequest:		"Unverbindliches und kostenloses Angebot anfordern",
		buttonRequestShort:	"Kostenloses Angebot anfordern",
		buttonCancel:		"Abbrechen",
	},
	form: commonLocale.form,
	requestform: {
		flight: {
			labelChecked:	"Organisieren Sie meine Anreise von",
			label:			"Organisieren Sie meine Anreise"
		},
		postCode:{
			label:			"PLZ",
			placeholder:	"PLZ",
		},
		country:{
			label:	"Land",
		},
		nrAdults: {
			label:	"Erwachsene"
		},
		nrBabies: {
			label:	"Kinder (0-2 Jahre)"
		},
		kids:	"Kinder",
		nrKids: {
			label:	"Kinder (3-11 Jahre)"
		},
		roomSingle: {
			label:	"Einzelzimmer"
		},
		roomDouble: {
			label:	"Doppelzimmer"
		},
		kidBeds: {
			label:	"Beistellbetten"
		},
		babyBeds: {
			label:	"Babybetten"
		},
		duration: {
			label:	"Gewünschte Reisedauer"
		},
		startIntro:	"Ich möchte reisen zwischen",
		start: {
			label:	"Startdatum",
		},
		end: {
			label:	"Enddatum",
		},
		rentalCar: {
			label:	"Organisieren Sie einen Mietwagen"
		},
		rentalCarCategory: {
			label:	"Mietwagen-Kategorie"
		},
		hotelCategory: {
			label:	"Hotelkategorie"
		},
		notes: {
			label:			"Anmerkungen",
			placeholder:	"Haben Sie noch besondere Anforderungen, zum Beispiel an Barrierefreiheit, oder Wünsche an Ihre Reise? Hier ist Platz dafür.",
		},
	},
	requestroute: {
		title:		"Reiseroute",
		noOffer:	"Sie haben noch keine Reiseziele ausgewählt. Konfigurieren Sie sich auf der vorhergehenden Seite Ihre persönliche Traumreise oder schreiben Sie uns Ihre Anmerkungen und wir helfen Ihnen gerne weiter.",
		show:		"Details anzeigen",
		hide:		"Details verbergen"
	},
	requestSuccess: {
		title:		"Vielen Dank für Ihre Anfrage",
		text1:		"Gleich sollten Sie eine Bestätigungs-E-Mail mit Ihren Reiseangaben erhalten. Einer unserer Mitarbeiter erstellt aus Ihren Angaben ein individuelles Reiseangebot für Sie.",
		text2:		"In der Regel melden wir uns bei Ihnen innerhalb von 24 Stunden. Bitte haben Sie Verständnis, dass es am Wochenende etwas länger dauern kann. Wir antworten auf alle Anfragen vom Wochenende ab Montagmorgen.",
		text3:		"Ihre Reiseroute bleibt in Ihrem Browser gespeichert, damit Sie sie auch später noch ansehen und verändern können.",
		greetings:	"Beste Grüße aus Heidelberg",
		signature:	"Ihr Geotoura-Team",
	},
	requestError: {
		title:	"Fehler beim Abschicken",
		text:	"Beim Absenden ist leider ein Fehler aufgetreten und Ihre Anfrage konnte nicht abgeschickt werden. Ihre Route bleibt aber in Ihrem Browser gespeichert. Bitte versuchen Sie es zu einem anderen Zeitpunkt noch einmal oder kontaktieren Sie uns direkt unter",
		link:	sharedLocale.phone,
	},
	routeDelete: {
		title:			"Route wirklich löschen?",
		message:		"Diese Aktion löscht ihre gesamte Reiseroute.",
		confirmTitle:	"Route löschen"
	},
	route: {
		title:		"Meine Route",
		stop:		"Station",
		stops:		"Stationen",
		night:		"Übernachtung",
		nights:		"Übernachtungen",
		activity:	"Erlebnis",
		activities:	"Erlebnisse",
		wish:		"Wunsch",
		wishes:		"Wünsche",
		clearRoute:	"Ganze Route löschen",
		request:	"Angebot anfordern",
		empty:		"Sie haben noch keine Stationen in Ihrer Route. Klicken Sie ein Reiseziel auf der Karte an, um Stationen zu Ihrer Route hinzuzufügen!",
		back:		"Zurück zur Karte",
	},
	routebar: {
		showRoute:			"Route anzeigen",
		hideRoute:			"Route einklappen",
		showDestination:	"Ortsbeschreibung anzeigen",
		hideDestination:	"Ortsbeschreibung einklappen",
		summary: {
			stops:		"Stationen",
			hotels:		"Nächte",
			activities:	"Erlebnisse",
			wishes:		"Wünsche",
			request:	"Angebot",
		},
		station:		"Station",
		currentStation:	"Aktueller Ort",
		previous:		"Zum vorherigen Ort in der Route",
		next:			"Zum nächsten Ort in der Route",
		back:			"Zurück zur Geotoura-Startseite"
	},
	routestop: {
		wish:				"Wünsche",
		removeWish:			"Wunsch entfernen",
		removeActivity:		"Erlebnis entfernen",
		activeDestination:	"Aktuelle Destination",
		addToRoute:			"Zur Route hinzufügen",
		moveUp:				"Nach oben verschieben",
		moveDown:			"Nach unten verschieben",
		showDestination:	"Zur Ortsbeschreibung"
	},
	search: {
		placeholder:	"Ort suchen",
		label:			"Ort suchen",
		noMatches:		"keine Treffer für Ihre Suche",
		clearInput:		"Eingabe löschen"
	},
	sights: {
		show:		"mehr Informationen",
		hide:		"weniger Informationen",
		h3Title:	"Mehr über den Ort"
	},
	wish: {
		title:			"Besondere Wünsche",
		info:			"Schreiben Sie uns, was Sie gern unternehmen oder erleben möchten – unsere landeskundigen MitarbeiterInnen organisieren es für Sie.",
		placeholder:	"Sollen wir an diesem Ort etwas Besonderes für Sie organisieren? Ein Konzertbesuch, Opernabend oder ein Picknick im Park? Hier ist Platz für Ihre Wünsche …",
		add:			"Wunsch zur Route hinzufügen",
		change:			"ändern",
		label:			"Wunsch",
	},
};
